import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useModuloControle } from '../../../contexts/ModuloControleContext';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';

const Navigation = () => {
  const location = useLocation();
  const {
    bloquearMenu,
  } = useModuloControle();

  if (bloquearMenu.gestao) {
    return null;
  }

  const items = [
    { to: '/dashboard', label: 'Início', Icon: HomeOutlinedIcon, activeWhen: ['/dashboard'] },
    { to: '/history/mobile', label: 'Histórico', Icon: HistoryOutlinedIcon, activeWhen: ['/history/mobile'] },
    { to: '/relatorios/nfe', label: 'Relatórios', Icon: AssessmentOutlinedIcon, activeWhen: ['/relatorios'] },
    { to: '/usuarios/editarPerfil', label: 'Perfil', Icon: PersonOutlineOutlinedIcon, activeWhen: ['/usuarios/editarPerfil'] },
  ];

  const isActive = (activeWhen) => activeWhen.some((prefix) => location.pathname.startsWith(prefix));

  return (
    <nav className='mobile-bottom-nav' aria-label='Menu principal'>
      {items.map(({ to, label, Icon, activeWhen }) => {
        const active = isActive(activeWhen);
        return (
          <Link key={to} to={to} className={['mobile-bottom-nav__item', active && 'active'].filter(Boolean).join(' ')}>
            <Icon className='mobile-bottom-nav__icon' />
            <span className='mobile-bottom-nav__label'>{label}</span>
          </Link>
        );
      })}
    </nav>
  );
};

export default Navigation;
